<template>
    <!-- eslint-disable vue/no-v-html -->
    <div
        v-if="sanitizedDescription"
        ref="readMoreContentElement"
        :data-testid="props.dataTestid || 'experience-item-description'"
        class="profile__experience-item__description"
        :class="{'profile__experience-item__description--collapsed': isCollapsed}"
        v-html="sanitizedDescription"
    ></div>
    <!-- eslint-enable vue/no-v-html -->
    <VJoyLink
        v-if="shouldDisplayShowMore"
        href="#"
        :text="isCollapsed ? t('profile.section.pof.show.more') : t('profile.section.pof.show.less')"
        data-testid="toggle-show-all-experiences"
        @click="isCollapsed ? handleShowMoreExpand() : handleShowMoreCollapse()"
    />
</template>
<script setup lang="ts">
    import {computed, ref, toRef, useTemplateRef} from 'vue';
    import {useMarkdownToHtml, useTranslation} from '#imports';
    import {VJoyLink} from '@maltjoy/core-vue';
    import {overrideH1ToH3} from '~/config/mdToHtmlOverrides';

    const props = defineProps<{
        description?: string;
        dataTestid?: string;
    }>();

    const {t} = useTranslation();
    const {markdownToHtml} = useMarkdownToHtml();

    const rawDescription = toRef(props, 'description');
    const isCollapsed = ref<boolean>(true);
    const readMoreContentElement = useTemplateRef<HTMLElement>('readMoreContentElement');
    const readMoreContentScrollHeight = computed(() => readMoreContentElement.value?.scrollHeight || 0);
    const readMoreContentClientHeight = computed(() => readMoreContentElement.value?.clientHeight || 0);
    const shouldDisplayShowMore = computed(() => readMoreContentScrollHeight.value > readMoreContentClientHeight.value);
    const sanitizedDescription = computed(() => markdownToHtml(rawDescription.value, overrideH1ToH3));

    function handleShowMoreCollapse() {
        isCollapsed.value = true;
    }

    function handleShowMoreExpand() {
        isCollapsed.value = false;
    }
</script>
<style lang="scss">
    .profile__experience-item__description {
        line-break: anywhere;

        &--collapsed {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
        }
    }
</style>
